import { LabelsContext } from "./LabelsContext";
export { Label } from "./Label";
export { LabelsContext } from "./LabelsContext";
export const LabelsProvider = LabelsContext.Provider;
//# sourceMappingURL=index.js.map